import Icon from '../components/Icon.vue'

Icon.register({
  biking: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M400 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM396 217l-41.4-33.1-58.3 49.9 41.4 27.6c7.9 5.2 14.2 17.2 14.3 26.6v128c0 17.7-14.3 32-32 32s-32-14.3-32-32v-110.9l-81.7-54.5c-7.9-5.2-14.3-17.2-14.3-26.6 0-8.1 5-19 11.2-24.3l112-96c5-4.3 14.3-7.7 20.8-7.7 6.2 0 15.2 3.2 20 7l71.2 57h52.8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-64-0.1c-6.2 0-15.1-3.1-19.9-7zM512 256c70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128 57.3-128 128-128zM512 448c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM128 256c70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128 57.3-128 128-128zM128 448c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/biking.js
// module id = 661
// module chunks = 0